import React from "react";
import { useEffect, useState } from "react";
import * as Survey from "survey-react";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import { getTemplate, UpdateLabResult } from "../../services/Api";
import {  getList,postList,genericPost,genericGet } from "../../services/Api";
import { ENDPOINTS } from "../../Constants";

import moment from "moment";

import { useHistory } from "react-router-dom";

import "survey-react/survey.css";
const LabResultFrom = (props) => {
  const history = useHistory();
  const { patient_info, room } =
    (props.location && props.location.state) || {};
  const [template, settemplate] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [started, setSaterted] = useState();

  useEffect(() => {
    // getLabRequestTemplate();
    getResultTemplate();
    setSaterted(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

    return () => {};
  }, []);



  const getResultTemplate = () => {
 
  
    setIsloading(true);
  genericPost(ENDPOINTS.LAB_RESULT_TEMPLATE, {
    "service_request_id":patient_info?.service_request_id
    })
      .then((res) => {
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let tmp = res.data.data.template;
           settemplate(tmp);
         
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
        setIsloading(false);
      })
      .catch((err) => {
        console.log("Error:: ");
        console.log(err);
        setIsloading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };
  const _submit = (form_result) => {
 
    let payload = {
      service_request_id: patient_info?.service_request_id,
      // from_room_id: room.id,
      // room_id: "5329c17d-81f1-11ec-81e5-0a9ea65235cc", // get lab room id
      lab_results:   form_result.valuesHash,
      "started_at":"2022-01-19 16:06:00",
      "ended_at":"2022-01-19 16:06:01",
      "status":10002
    };
    console.clear();
    console.log(payload);

    setIsloading(true);
    UpdateLabResult(payload)
      .then((res) => {
        setIsloading(false);
        var response = res.data;

        console.log(res);
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.log(response);

            cogoToast.success("Lab Request Created Successfully", {
              hideAfter: 5,
            });
            //   history.push({
            //     pathname: "/hmis/print-visit",
            //     state: {
            //       visit: response.data,

            //     },
            //   });
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  const getLabRequestTemplate = () => {
    setIsloading(true);

    getTemplate({ template_name: "lab-test-request" })
      .then((res) => {
        console.log(res);
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;

          let tmp = response.data[0].template;
          settemplate(tmp);

          if (response.status == SUCCESS_RESULT) {
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  return (
    <h1>
      {/* LAB RESULT FORM */}
      {/* {JSON.stringify(patient_info)}
      <hr/>
      {JSON.stringify(template)} */}
      <h1 className="alert alert-primary">
      {room.room_name} -   RESULT ENTRY  ➤   Patient : {patient_info.name}
            {/* {JSON.stringify(patient_info)} */}
          </h1>
      <hr />
      <div className="d-flex justify-content-center my-1">
        {Isloading && <Spinner />}
      </div>
      {template != null && (
        <Survey.Survey json={template} onComplete={(data) => _submit(data)} />
      )}
    </h1>
  );
};

export default LabResultFrom;
